import { render, staticRenderFns } from "./ModalIcmsInterestadual.vue?vue&type=template&id=a95742ba&scoped=true&"
import script from "./ModalIcmsInterestadual.vue?vue&type=script&lang=js&"
export * from "./ModalIcmsInterestadual.vue?vue&type=script&lang=js&"
import style0 from "./ModalIcmsInterestadual.vue?vue&type=style&index=0&id=a95742ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95742ba",
  null
  
)

export default component.exports